<template>
  <a-form autocomplete="off" :form="form.fc" @submit="handleSubmit">
    <a-form-item>
      <a-row>
        <h2>{{ $t('scope.register.welcome') }}</h2>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="16">
          <a-checkbox v-decorator="decorator.isAgreement" @change="handleAgreementchange">
            <router-link target="_blank" :to="{ name: 'Agreement'}">{{$t('scope.user_agreement')}}</router-link>&
            <router-link target="_blank" :to="{ name: 'PrivacyPolicy'}">{{$t('scope.private_policy')}}</router-link>
          </a-checkbox>
        </a-col>
        <a-col :span="8">
          <p style="text-align: right"><router-link :to="{ name: 'Login'}">{{$t('scope.text_329')}}</router-link></p>
        </a-col>
      </a-row>
    </a-form-item>
    <a-form-item>
      <a-button size="large" type="primary" html-type="submit" :loading="loading" block :disabled="disabled">{{$t('scope.text_330')}}</a-button>
    </a-form-item>
  </a-form>
</template>

<script>
import { setSsoIdpIdInCookie } from '@/utils/auth'

export default {
  name: 'RegisterByOauth',
  props: {
    idps: {
      type: Array,
      required: true,
    },
    params: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      disabled: true,
      form: {
        fc: this.$form.createForm(this),
      },
      decorator: {
        isAgreement: [
          'isAgreement',
          {
            initialValue: false,
          },
        ],
      },
      isAgreement: false,
    }
  },
  methods: {
    ssoLogin () {
      setSsoIdpIdInCookie(this.params.idp_id)
      // icon_uri:"https://open.weixin.qq.com/
      const isWechat = this.idps.some(idp => { return idp.icon_uri && idp.icon_uri.contains('weixin.qq.com') })
      if (isWechat) {
        this.$router.push({
          path: 'registerresult',
          query: {
            ...this.$route.query,
            user_name: '',
          },
        })
      } else {
        window.location.href = `${origin}/api/v1/auth/sso/redirect/${this.params.idp_id}`
      }
    },
    handleAgreementchange (e) {
      this.disabled = !e.target.checked
    },
    registering () {
      this.loading = true
      this.$emit('register', this.loading)
    },
    registered () {
      this.loading = false
      this.$emit('register', this.loading)
    },
    handleSubmit (e) {
      e.preventDefault()
      this.form.fc.validateFields(async (err, values) => {
        if (err) return
        this.registering()
        try {
          Reflect.deleteProperty(values, 'isAgreement')
          const { invite } = this.$route.query
          if (invite) values.invite = invite
          values.method = 'oauth'
          Object.assign(values, this.params)
          await this.$http.post('/v2/register/customers', values)
          this.registered()
          this.ssoLogin()
        } catch {
          this.registered()
        }
      })
    },
  },
}
</script>

<style scoped>

</style>
